import { _ForceValidation } from '@/types/interfaces/vue-i18n'
import en from './en.json'
import ja from './ja.json'

export enum Locales {
  EN = 'en',
  JA = 'ja',
}

export const messages = {
  [Locales.EN]: en,
  [Locales.JA]: ja,
}

const setDateTimeFormats = {
  short: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
}

export const datetimeFormats = {
  en: setDateTimeFormats,
  ja: setDateTimeFormats,
}

// This type assertion will fail compilation if keys don't match
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _: _ForceValidation = true as _ForceValidation

export const defaultLocale = Locales.EN
